import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import { useRouter } from 'next/router';
import { useState } from 'react';
import ProductNav from '../../../common/ProductNav';
import { tabsValues } from '../../../config/pageConfig';
import Bundles from '../Bundles';
import BannerA from '../components/BannerA';
import BuiltTough from '../components/BuiltTough';
import CampingPower from '../components/CampingPower';
import Essentital from '../components/Essential';
import Explore from '../components/Explore';
import GoLight from '../components/GoLight';
import InBox from '../components/InBox';
import ItConnects from '../components/ItConnects';
import ItFits from '../components/ItFits';
import ItPowers from '../components/ItPowers';
import OnePower from '../components/OnePower';
import PageNavLeft from '../components/PageNavLeft';
import PortableDesign from '../components/PortableDesign';
import PowerStation from '../components/PowerStation';
import ProductList from '../components/ProductList';
import Subscribe from '../components/Subscribe';
import TabSwriper from '../components/TabSwriper';
import TabSwriper1 from '../components/TabSwriper1';
import TabSwriper2 from '../components/TabSwriper2';
import TC from '../components/TC';
import TrustedBy from '../components/TrustredBy';
import VideoFrame from '../components/VideoFrame';
import FQA from '../components/FQA';
import getLocal from '@/app/utils/i18n';
import Spec from '../../specs';
import Support from '../../support';
import TabSwriper2Ph from '../components/TabSwriper2Ph';

export default function StatusItem() {
    const { query } = useRouter();
    const { t } = useLang('TrailSeries.navList');
    const searchTab = query?.tab;
    let defaultTab = 'Product';
    if (typeof searchTab === 'string' && tabsValues.includes(searchTab)) {
        defaultTab = searchTab;
    }
    const [activeTab, setActiveTab] = useState(defaultTab);
    const tabCallback = (tabValue: string) => {
        setActiveTab(tabValue);
    };
    const { locale } = getLocal();
    return (
        <>
            <ProductNav activeTab={defaultTab} tabCallback={tabCallback} />
            {activeTab === 'Product' && (
                <>
                    <BannerA />

                    {locale !== 'ph' && (
                        <>
                            <EcoSpace hPc="180px" />
                            <Subscribe />
                        </>
                    )}
                    <div className="range1">
                        <CampingPower />
                        <EcoSpace hPc="180px" />
                        {/* <VideoFrame />
                        <EcoSpace hPc="180px" /> */}
                        <ProductList />
                    </div>

                    <div className="range2">
                        <ItFits />
                        <EcoSpace hPc="180px" />
                        <GoLight />
                        <EcoSpace hPc="180px" />
                        <PortableDesign />
                        <EcoSpace hPc="180px" />
                    </div>
                    <div className="range3">
                        <ItPowers />
                        <EcoSpace hPc="180px" />
                        <Essentital />
                        <EcoSpace hPc="180px" />
                        <PowerStation />
                        <EcoSpace hPc="180px" />
                        <TabSwriper />
                        <EcoSpace hPc="180px" />
                    </div>
                    <div className="range4">
                        <ItConnects />
                        <EcoSpace hPc="180px" />
                        <OnePower />

                        <TabSwriper1 />
                    </div>

                    <div className="range5">
                        <BuiltTough />
                    </div>
                    <div className="range6">{locale === 'ph' ? <TabSwriper2Ph /> : <TabSwriper2 />}</div>

                    <EcoSpace hPc="180px" />
                    <TrustedBy />
                    <EcoSpace hPc="180px" />
                    <InBox />
                    <EcoSpace hPc="180px" />
                    <Explore />
                    <EcoSpace hPc="180px" />
                    {!['us', 'ca', 'ph'].includes(locale) && (
                        <>
                            <FQA />
                            <EcoSpace hPc="180px" />
                            <TC />
                        </>
                    )}
                    {/* 左侧锚点 */}
                    <PageNavLeft
                        triggerElement=".trail-series"
                        enterElement="#CampingPower"
                        steps={[
                            { text: t('item1'), href: '#CampingPower' },
                            { text: t('item2'), href: '#ItFits' },
                            { text: t('item3'), href: '#ItPowers' },
                            { text: t('item4'), href: '#ItConnects' },
                            { text: t('item5'), href: '#BuiltTough' },
                            { text: t('item6'), href: '#TabSwriper2' },
                        ]}
                    />
                </>
            )}
            {activeTab === 'Bundles' && (
                <>
                    <Bundles />
                </>
            )}
            {/* {activeTab === 'Spec' && (
                <>
                    <Spec />
                </>
            )}
            {activeTab === 'Support' && (
                <>
                    <Support />
                </>
            )} */}
        </>
    );
}
